<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    this.$router.push(this.$store.state.app.brand.home)
  },
}
</script>
